import { render, staticRenderFns } from "./Predictive_Form.vue?vue&type=template&id=32a32bae&scoped=true"
import script from "./Predictive_Form.vue?vue&type=script&lang=js"
export * from "./Predictive_Form.vue?vue&type=script&lang=js"
import style0 from "./Predictive_Form.vue?vue&type=style&index=0&id=32a32bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a32bae",
  null
  
)

export default component.exports